import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';

const ACHIEVEMENT_DATA = DATA.achievement;

const Achievement = () => {
    
    return (
        <section id='achievement-id' className="achievement-block container">
            <p className="title">{ACHIEVEMENT_DATA.title}</p>
            <div className="content">
                <div className="item first">
                    <p className="first__text" dangerouslySetInnerHTML={{__html: ACHIEVEMENT_DATA.list[0].text}}/>
                    <div className="first__images">
                        {ACHIEVEMENT_DATA.list[0].images.map((image, index) => {
                            return (
                                <img key={index} src={image} alt=''/>
                            )
                        })}
                    </div>
                </div>
                <div className="item other">
                    {ACHIEVEMENT_DATA.list.slice(-2).map((item, index) => {
                        return (
                            <div className="other__content" key={index}>
                                <img key={index} src={item.images[0]} alt='' className="other__image"/>
                                <p className="other__text" dangerouslySetInnerHTML={{__html: item.text}}/>
                            </div>
                        )
                    })}
                </div>
             
            </div>
        </section>
    )
}

export default Achievement